// extracted by mini-css-extract-plugin
export default {"specialtyModIcon":"_2fR4g","lowRes":"_1MCC5"};